import { RunningExperiments, useExperiments } from 'state/experiments';

export const useLocationModalWithMap = () => {
  const { variant } = useExperiments();

  const isLocationModalWithMapEnabled = variant(
    RunningExperiments.LocationModalWithMap,
    'treatment',
    {
      skipExposureLogging: true,
    }
  );

  return isLocationModalWithMapEnabled;
};
